import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { PAYMENTS_INCOMING_WIRE_BASE_PATH } from '../../../../../../../../../features/payments/incoming-wire/payments-incoming-wire-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/incoming-wire/_incoming-wire')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'incoming-wire-payment-list',
        label: 'Payments',
        to: PAYMENTS_INCOMING_WIRE_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
